exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PageTitle-module__pagetitle___3s1mj h1{line-height:50px;margin:0}.PageTitle-module__pagetitle___3s1mj h2{margin-bottom:45px;margin-top:10px}", ""]);

// exports
exports.locals = {
	"pagetitle": "PageTitle-module__pagetitle___3s1mj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/components/UI/PageTitle/PageTitle.module.scss
// module id = p01a
// module chunks = 0